// src/config/env.ts

const isDev = import.meta.env.DEV === true;

function normalizeAssetsBaseUrl(value: string) {
  const trimmed = value.trim();
  if (!trimmed) return "";

  // CDN assets are served over HTTPS; auto-correct accidental HTTP env values.
  if (trimmed === "http://cdn.tranzytours.com" || trimmed === "http://cdn.tranzytours.com/") {
    return "https://cdn.tranzytours.com";
  }

  return trimmed.replace(/\/+$/, "");
}

export const env = {
  // ---------------------------------------------------------------------------
  // App identity
  // ---------------------------------------------------------------------------
  APP_NAME: import.meta.env.VITE_APP_NAME ?? "Tranzy Tours",

  // ---------------------------------------------------------------------------
  // Environment metadata
  // ---------------------------------------------------------------------------
  APP_ENV: import.meta.env.VITE_APP_ENV ?? (isDev ? "development" : "staging"),
  APP_URL:
    import.meta.env.VITE_APP_URL ??
    (isDev ? "http://localhost:5173" : ""),

  // ---------------------------------------------------------------------------
  // API configuration
  // ---------------------------------------------------------------------------
  /**
   * IMPORTANT:
   * - In dev: fall back to localhost
   * - In staging/prod: NEVER fall back to localhost
   */
  API_BASE_URL: (() => {
    const v = import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL;
    if (v) return v as string;
    throw new Error("VITE_API_BASE_URL is required");
  })(),

  API_VERSION: import.meta.env.VITE_API_VERSION ?? "v1",

  API_WITH_CREDENTIALS:
    String(import.meta.env.VITE_API_WITH_CREDENTIALS ?? "true") === "true",

  // ---------------------------------------------------------------------------
  // Asset / media configuration
  // ---------------------------------------------------------------------------
  /**
   * Base URL for assets (images, branding, etc.)
   * - Use empty string to serve from same domain
   * - Must NOT be undefined
   */
  ASSETS_BASE_URL: (() => {
    if (import.meta.env.VITE_ASSETS_BASE_URL !== undefined)
      return normalizeAssetsBaseUrl(import.meta.env.VITE_ASSETS_BASE_URL as string);

    return "";
  })(),

  // ---------------------------------------------------------------------------
  // Image constraints
  // ---------------------------------------------------------------------------
  IMAGE_MAX_MB: Number(import.meta.env.VITE_IMAGE_MAX_MB ?? 10),

  ALLOWED_IMAGE_TYPES: String(
    import.meta.env.VITE_ALLOWED_IMAGE_TYPES ??
      "jpg,jpeg,png,webp,avif"
  )
    .split(",")
    .map((s) => s.trim().toLowerCase()),
} as const;
